import React from 'react';
import logo from './logo.svg';
import {Avatar, Box, Grid, Sheet, Stack} from '@mui/joy';
import Description from "./Description";
import Photo from "./Photo";
import Service from './Service';
import {Circle} from "@mui/icons-material";
import {SkillModel} from "../model/skill";
import {ServiceModel} from "../model/service";
import Skill from "./Skill";

function Services({services} :{services: Array<ServiceModel>}) {
    return (
        <Stack direction='row' sx={{justifyContent: 'space-around', alignItems: 'flex-start', borderRadius: 8,}}>
            <Box display={{xs: 'none', lg: 'block'}}>
                <Avatar sx={{width: 128, height: 128}} size='sm' variant='soft' color='primary'>
                    <Circle sx={{fontSize: 128}}/>
                </Avatar>
            </Box>

            <Sheet
                sx={{
                    paddingY: 4,
                    paddingX: 6,
                    width: '100%',
                    maxWidth: 800,
                    borderRadius: 16,
                }}>
                <Stack sx={{padding: 0}} justifyContent={{xs: 'start', md: 'space-around'}}
                       alignItems={{xs: 'stretch', md: 'start'}} direction={{xs: 'column', md: 'row'}}
                       spacing={{xs: 1, sm: 2, md: 2}}>
                    {
                        services.map(value => (
                            <Service service = {value} />
                        ))
                    }

                </Stack>
            </Sheet>
        </Stack>
    );
}

export default Services;